import React, { PureComponent } from 'react';
import './ad.scss';
import http from '@/server';
import { CloseCircleOutlined } from '@ant-design/icons';

class AD extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      adArr: [],
      coupletAd: [],
      floatAd: [],
      timeout: '',
    };
  }

  componentDidMount() {
    this.getAD(4, (res) => {
      this.setState({
        ...this.state,
        coupletAd: res.data.data,
      });
    });
    this.getAD(3, (res) => {
      this.setState({
        ...this.state,
        floatAd: res.data.data,
      });
      let timeout = setTimeout(() => {
        this.state.floatAd &&
          this.state.floatAd.map((item, index) => {
            this.params(index, item);
            return null;
          });
        let floatAdArr = [...document.querySelectorAll('.floatAd-box')];
        floatAdArr.map((item, index) => {
          item.addEventListener('mouseenter', () => {
            this.state.adArr &&
              this.state.adArr[index] &&
              clearInterval(this.state.adArr[index]);
          });
          item.addEventListener('mouseleave', () => {
            this.state.floatAd &&
              this.state.floatAd[index] &&
              this.params(index, this.state.floatAd[index]);
          });
          return null;
        });
      }, 1000);
      this.setState({
        timeout: timeout,
      });
    });
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    if (this.state.adArr.length > 0) {
      for (let index = 0; index < this.state.adArr.length; index++) {
        const element = this.state.adArr[index];
        clearInterval(element);
      }
    }
  }

  getAD = (id, callback) => {
    let params = {
      page: 1,
      pageSize: 10,
      cid: id,
    };
    http.get('/ad/achieve_ad', params).then((res) => {
      callback(res);
    });
  };

  params = (index, item) => {
    let stepX = 1;
    let stepY = 1;
    let img = document.querySelectorAll('.floatAd-box')[index];
    if (img && img.offsetWidth && img.offsetHeight) {
      let imgWidth = img.offsetWidth;
      let imgHeight = img.offsetHeight;
      let clientw = document.documentElement.clientWidth; //1903（不包含滚动条）
      let clienth = document.documentElement.clientHeight; //866（不包含工具条）
      let x = parseInt(img.getBoundingClientRect().left);
      let y = parseInt(img.getBoundingClientRect().top);
      let adArr = this.state.adArr;
      adArr[index] = setInterval(() => {
        let distenceX = clientw - x;
        let distenceY = clienth - y;
        if (distenceX - imgWidth < 0 || distenceX > clientw) {
          stepX = -stepX;
        }
        if (distenceY - imgHeight < 0 || distenceY > clienth) {
          stepY = -stepY;
        }
        x += stepX;
        y += stepY;
        this.changePos(img, x, y);
      }, item.speed);
      this.setState({
        ...this.state,
        adArr: adArr,
      });
    }
  };

  changePos = (img, x, y) => {
    img.style.left = x + 'px';
    img.style.top = y + 'px';
  };

  render() {
    return (
      <div className="AD">
        <div className="coupletAd">
          {this.state.coupletAd &&
            this.state.coupletAd.map((item, index) => {
              return item.location === 1 || item.location === 3 ? (
                <div
                  className="left-box"
                  style={{
                    top: item.top + 'px',
                  }}
                  key={item.id}
                >
                  <CloseCircleOutlined
                    onClick={() => {
                      document.querySelectorAll('.left-box')[
                        index
                      ].style.display = 'none';
                    }}
                  />
                  <img
                    src={http.baseURL + item.pic_url}
                    alt=""
                    style={{
                      width: item.adwidth + 'px',
                      height: item.adheight + 'px',
                    }}
                    onClick={() => {
                      window.open(item.url);
                    }}
                  />
                  {/* <span className="title">{item.title}</span> */}
                </div>
              ) : null;
            })}
          {this.state.coupletAd &&
            this.state.coupletAd.map((item, index) => {
              return item.location === 2 || item.location === 3 ? (
                <div
                  className="right-box"
                  style={{
                    top: item.top + 'px',
                  }}
                  key={item.id}
                >
                  <CloseCircleOutlined
                    onClick={() => {
                      document.querySelectorAll('.right-box')[
                        index
                      ].style.display = 'none';
                    }}
                  />
                  <img
                    src={http.baseURL + item.pic_url}
                    alt=""
                    style={{
                      width: item.adwidth + 'px',
                      height: item.adheight + 'px',
                    }}
                    onClick={() => {
                      window.open(item.url);
                    }}
                  />
                  {/* <span className="title">{item.title}</span> */}
                </div>
              ) : null;
            })}
        </div>
        <div className="floatAd">
          {this.state.floatAd &&
            this.state.floatAd.map((item, index) => {
              return (
                <div
                  className="floatAd-box"
                  style={{
                    top: item.top + 'px',
                  }}
                  key={item.id}
                >
                  <CloseCircleOutlined
                    onClick={() => {
                      document.querySelectorAll('.floatAd-box')[
                        index
                      ].style.display = 'none';
                    }}
                  />
                  <img
                    src={http.baseURL + item.pic_url}
                    alt=""
                    style={{
                      width: item.adwidth + 'px',
                      height: item.adheight + 'px',
                    }}
                    onClick={() => {
                      window.open(item.url);
                    }}
                  />
                  {/* <span className="title">{item.title}</span> */}
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

export default AD;
